"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.datapoolForKeyspace = exports.belongsToDatapool = exports.datapoolFromKeyspace = exports.isDatapoolKeyspace = void 0;
var datapoolKeyspaceRegex = /datapool_[0-9A-z]+/;
var isDatapoolKeyspace = function (keyspaceName) {
    return datapoolKeyspaceRegex.test(keyspaceName);
};
exports.isDatapoolKeyspace = isDatapoolKeyspace;
var datapoolFromKeyspace = function (keyspaceName) {
    return (0, exports.isDatapoolKeyspace)(keyspaceName) ? keyspaceName.split('_')[1] : keyspaceName;
};
exports.datapoolFromKeyspace = datapoolFromKeyspace;
// TODO remove duplication
function belongsToDatapool(keyspaceName) {
    if (!keyspaceName)
        return false;
    return keyspaceName.startsWith('datapool_');
}
exports.belongsToDatapool = belongsToDatapool;
function datapoolForKeyspace(keyspaceName, summary) {
    if (!keyspaceName)
        return '';
    if (!summary || summary.length === 0)
        return '';
    var datapoolCode = keyspaceName.replace('datapool_', '');
    var datapool = undefined;
    for (var i = 0; i < summary.length; i++) {
        datapool = (summary[i].datapools || []).find(function (datapool) { return (datapool.code || '').toLowerCase() === datapoolCode; });
        if (datapool)
            break;
    }
    return (datapool === null || datapool === void 0 ? void 0 : datapool.name) || '';
}
exports.datapoolForKeyspace = datapoolForKeyspace;
//# sourceMappingURL=cassandra.js.map